import React from 'react';
import LoadingSpinner from '../../../uiToolkit/LoadingSpinner/LoadingSpinner';
import {postsText} from '../postsText';
import styles from './PostReorderColumn.module.css';

interface Props {
  index: number;
  total: number;
  onMove: (index: number, direction: 1 | -1) => void;
  busy?: boolean;
  disabled?: boolean;
}

const PostReorderColumn = React.memo(
  ({index, total, onMove, busy, disabled}: Props) => (
    <div
      className={styles.column}
      onClick={ev => ev.stopPropagation()}
      role="presentation">
      <button
        className={styles.button}
        onClick={() => onMove(index, -1)}
        disabled={index === 0 || disabled}
        title={postsText.moveUp}>
        ˄
      </button>
      {busy ? (
        <span className={styles.spinner}>
          <LoadingSpinner size={16} />
        </span>
      ) : (
        <span className={styles.number}>{index + 1}</span>
      )}
      <button
        className={styles.button}
        onClick={() => onMove(index, 1)}
        disabled={index === total - 1 || disabled}
        title={postsText.moveDown}>
        ˅
      </button>
    </div>
  ),
);

export default PostReorderColumn;
